export default "__VITE_ASSET__iiOo1a5U__"